import { render, staticRenderFns } from "./kxswill.vue?vue&type=template&id=85b70884"
import script from "./kxswill.vue?vue&type=script&lang=js"
export * from "./kxswill.vue?vue&type=script&lang=js"
import style0 from "./kxswill.vue?vue&type=style&index=0&id=85b70884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports